document.addEventListener("DOMContentLoaded", function () {
    const tables = document.querySelectorAll(".table-responsive[data-pattern]");

    if (tables.length) {
        import(/* webpackChunkName: "hypertherm-responsive-table" */ "/Features/ResponsiveTable/js/responsive-table.js").then((module) => {
            tables.forEach((wrapper) => {
                const responsiveTable = new module.default(wrapper);
                responsiveTable.init();
            });
        });
    }
});
